import { isNil } from 'lodash'

export default {
  user: state => state.user,
  isAuthenticated: state => !isNil(state.user)
}
